/* export default defineNuxtRouteMiddleware(async (to, from) => {
  try {
    await $fetch('/api/auth/user', { credentials: 'include' })
  } catch (error) {
    console.warn('User not authenticated, redirecting to login...')
    return navigateTo('/login')
  }
})
 */

export default defineNuxtRouteMiddleware((to, from) => {
  const user = useSupabaseUser()

  if (!user.value) {
    return navigateTo({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
})
